<template>
  <div id="not-found-page">
    <b-container>
      <b-row>
        <b-col id="title"> ERROR 404 </b-col>
      </b-row>
      <b-row class="mt-3">
        <b-col class="text-center">
          <b-img src="@/assets/images/not-found.png" fluid alt="Not Found" />
        </b-col>
      </b-row>
      <b-row class="mt-2 mb-5">
        <b-col id="message"> Oops! Page not found. </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>

export default {
  name: "NotFound"
};
</script>

<style lang="scss" scoped>
</style>
